import { render, staticRenderFns } from "./restaurantDetails.vue?vue&type=template&id=e5c853da&"
import script from "./restaurantDetails.vue?vue&type=script&lang=js&"
export * from "./restaurantDetails.vue?vue&type=script&lang=js&"
import style0 from "./restaurantDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports